import { Flex } from "@mantine/core"
import { ReactNode } from "react"

export function TableActions({ children }: { children: ReactNode }) {
  return (
    <Flex gap="xs" wrap="nowrap" align="center">
      {children}
    </Flex>
  )
}
